import React from "react";
import moment from "moment";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";

import {COLORS} from "../../../../../../../../../config/constants";
import { Edit, Receipt } from "@vedmarket/ui-kit";
import {getPluralForm} from "../../../../../../../../../utils/validation";

import './../../invoice.scss';
import {numberWithSpaces} from "../../../../../../../../../utils/helpers";
import {useDemoInvoiceTitle} from 'components/cabinet/demo/steps/packaging/use-packaging';

type Props = {
    invoice?: InvoiceParamsOutput
    index: number
}

const InvoiceTitle = ({invoice, index} : Props) => {

  const { t } = useTranslation()

  const invoiceId = invoice?.id;
  const demoPlayback = useDemoInvoiceTitle(invoiceId)

  const PRODUCTS_DECLENSIONS: PluralForms = [ t('declension__text__itemOne'), t('declension__text__itemSeveral'), t('declension__text__itemMany') ];

  return (
    <div className='invoice-title'>
      <div className='invoice-title__left'>
        {demoPlayback.visibleInvoiceId
          ? <Receipt color={COLORS.GREEN}/>
          : <Edit color={COLORS.LIGHT_TEXT_DISABLED_OPACITY}/>}
        <div  className='invoice-title__information'>
          <Typography variant='h6' className='invoice-title__name' sx={{
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '26px',
            letterSpacing: 0,
          }}>
            {`${index + 1}. ${demoPlayback.visibleInvoiceId ? invoice?.description || '' : t('common__text__invoice')}`}
          </Typography>
          {demoPlayback.visibleInvoiceId && <Typography variant='body2' sx={{color: COLORS.LIGHT_TEXT_DISABLED, lineHeight: '21px', letterSpacing: 0}}>
            {`${t('common__text__invoice')}  № ${invoice?.invoice_num} ${t('common__text__from')} ${moment(invoice?.invoice_date).format('DD.MM.YYYY')}`}
          </Typography>}
        </div>
      </div>
      {demoPlayback.visibleInvoiceId && demoPlayback.shouldShowProductInformation && (
        <div className='invoice-title__right'>
          <Typography variant='h6' sx={{fontSize: '20px', fontWeight: 400, lineHeight: '26px', letterSpacing: 0}}>
            {numberWithSpaces(invoice?.price_total)} USD
          </Typography>
          <Typography variant='body2' sx={{color: COLORS.LIGHT_TEXT_DISABLED, lineHeight: '21px', letterSpacing: 0}}>
            {`${invoice?.product_count} ${getPluralForm(invoice?.product_count || 0, PRODUCTS_DECLENSIONS)}`}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default InvoiceTitle
